import { TailSpin } from "react-loader-spinner";

const LoaderComponent = () => {
  return (
    <>
      <span>
        <TailSpin visible={true} height="20" width="20" color="#fff" />
      </span>
    </>
  );
};

export default LoaderComponent;
